import { memo, useEffect, useRef } from 'react';

import type { KcContext_SamlPostForm } from 'src/shared/utils/kc-context/kc-context.js';

export interface SamlPostFormProps {
    kcContext: KcContext_SamlPostForm;
}

export const SamlPostForm = memo<SamlPostFormProps>(({ kcContext }) => {
    const formRef = useRef<HTMLFormElement>(null);

    useEffect(() => {
        if (formRef.current) {
            formRef.current.submit();
        }
    }, []);

    const { samlPost } = kcContext;

    return (
        <form ref={formRef} action={samlPost.url} method="post" style={{ display: 'none' }}>
            {samlPost.SAMLRequest && <input type="hidden" name="SAMLRequest" value={samlPost.SAMLRequest} />}
            {samlPost.SAMLResponse && <input type="hidden" name="SAMLResponse" value={samlPost.SAMLResponse} />}
            {samlPost.relayState && <input type="hidden" name="RelayState" value={samlPost.relayState} />}
        </form>
    );
});
